// Code generated by Slice Machine. DO NOT EDIT.
// @ts-nocheck

import {defineSliceZoneComponents} from '@prismicio/vue';
import {defineAsyncComponent} from 'vue';

export const components = defineSliceZoneComponents({
    agenda: defineAsyncComponent(() => import('./Agenda/index.vue')),
    article_content: defineAsyncComponent(() => import('./Content/index.vue')),
    articles_list: defineAsyncComponent(() => import('./ArticlesList/index.vue')),
    author_biography: defineAsyncComponent(() => import('./AuthorBiography/index.vue')),
    button: defineAsyncComponent(() => import('./MaltButton/index.vue')),
    callout: defineAsyncComponent(() => import('./Callout/index.vue')),
    carousel: defineAsyncComponent(() => import('./Carousel/index.vue')),
    categories_list: defineAsyncComponent(() => import('./CategoriesList/index.vue')),
    collections_list: defineAsyncComponent(() => import('./CollectionsList/index.vue')),
    content_suggestions: defineAsyncComponent(() => import('./ContentSuggestions/index.vue')),
    events_list: defineAsyncComponent(() => import('./EventsList/index.vue')),
    guide_abstract: defineAsyncComponent(() => import('./GuideAbstract/index.vue')),
    guides_list: defineAsyncComponent(() => import('./GuidesList/index.vue')),
    list: defineAsyncComponent(() => import('./List/index.vue')),
    pinned_content_hero: defineAsyncComponent(() => import('./PinnedContentHero/index.vue')),
    quote: defineAsyncComponent(() => import('./Quote/index.vue')),
    related_content: defineAsyncComponent(() => import('./RelatedContent/index.vue')),
    selection: defineAsyncComponent(() => import('./Selection/index.vue')),
    speakers: defineAsyncComponent(() => import('./Speakers/index.vue')),
    success_stories_list: defineAsyncComponent(() => import('./SuccessStoriesList/index.vue')),
    table_slice: defineAsyncComponent(() => import('./TableSlice/index.vue')),
    trends_chart: defineAsyncComponent(() => import('./TrendsChart/index.vue')),
    trends_content: defineAsyncComponent(() => import('./TrendsContent/index.vue')),
    trends_details_carousel: defineAsyncComponent(() => import('./TrendsDetailsCarousel/index.vue')),
    trends_gaps: defineAsyncComponent(() => import('./TrendsGaps/index.vue')),
    trends_headlines: defineAsyncComponent(() => import('./TrendsHeadlines/index.vue')),
    trends_hero: defineAsyncComponent(() => import('./TrendsHero/index.vue')),
    trends_newsletter: defineAsyncComponent(() => import('./TrendsNewsletter/index.vue')),
    trends_on_demand_skills: defineAsyncComponent(() => import('./TrendsOnDemandSkills/index.vue')),
    trends_quadrant: defineAsyncComponent(() => import('./TrendsQuadrant/index.vue')),
    trends_quote: defineAsyncComponent(() => import('./TrendsQuote/index.vue')),
    trends_skills_index: defineAsyncComponent(() => import('./TrendsSkillsIndex/index.vue')),
    trends_testimonials: defineAsyncComponent(() => import('./TrendsTestimonials/index.vue')),
    trends_top_skills: defineAsyncComponent(() => import('./TrendsTopSkills/index.vue')),
    trends_video: defineAsyncComponent(() => import('./TrendsVideo/index.vue')),
    video_list: defineAsyncComponent(() => import('./VideoList/index.vue')),
    resources_list: defineAsyncComponent(() => import('./ResourcesList/index.vue')),
});
